import React from 'react';

import { Content } from './Content.js';

export default class SingleParagraphContents extends React.Component {

  render() {
    return (
      <div className="inner">
        <p className="centered">
          {Content[this.props.page].body1}
          &nbsp;
          <a href={Content[this.props.page].anchorHref}>{Content[this.props.page].anchorText}</a>
          &nbsp;
          {Content[this.props.page].signOff}
        </p>
      </div>
    );
  }

};
